import { StateSchema } from 'app/config/storeConfig/types';

export const getSelectedCard = (state: StateSchema): Nullable<string> => state.warehouseMap.selectedWarehouseCard;
